import React from "react"
import SeatStyle from "./seatAdmin.module.scss"
import { Button, Chip, Tooltip, Typography, styled, tooltipClasses } from "@mui/material";
import moment from 'moment'
import SteLib from "src/lib/stelib";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#253655',
    color: 'white',
    maxWidth: 290,
    padding: ".35rem .75rem",
    borderRadius: '.75rem'
  },
}));


class SeatAdmin extends React.Component {

  setSeat = (seat) => {
    this.props.setSeat(seat)
  }

  componentDidUpdate(prevProps) {
    //this.render(this.prop);
  }

  render() {
    let { seat, notAvailableSeats, currentSeats, handleSetPayedDone } = this.props;
    let available = true;
    let seatData = null;
    notAvailableSeats.map(nas => {if(nas.seatCode === seat){available = false; seatData = nas;} return true;});
    const isAvailable = available
    const payed = seatData?.type === 2;
    const isCurrent = currentSeats.indexOf(seat) >= 0
    const availableButtonClasses = 
      true ? 
        isCurrent ? `selectable ${SeatStyle.button} ${SeatStyle.current}` : `selectable ${SeatStyle.button}` :
        `${SeatStyle.button} ${SeatStyle.button_unavailable}`

    const availableButtonClassesPayed = 
          isCurrent ? `button_payed ${SeatStyle.button_payed} ${SeatStyle.current}` : `button_payed ${SeatStyle.button_payed}`
  
    const availableButtonClassesBooked = 
          isCurrent ? `button_booked ${SeatStyle.button_booked} ${SeatStyle.current}` : `button_booked ${SeatStyle.button_booked}`
  

    let setSeatPayed = () => {
      if(seatData.id > 0)
      {
        if(window.confirm("Confermi posto pagato?"))
        {
          SteLib.PutRequest("timetables/seats/"+seatData.id+"/setPayed", {}, false).then((data) => {
            handleSetPayedDone();
          });
        }
      }
    }

    let deleteBookedSeat = () => {
      if(seatData.id > 0)
      {
        if(window.confirm("Confermi eliminazione prenotazione?"))
        {
          SteLib.DeleteRequest("timetables/seats/"+seatData.id, {}, false).then((data) => {
            handleSetPayedDone();
          });
        }
      }
    }

    return (
      <div key={seat}>
        { isAvailable ? (     
          <HtmlTooltip
          title={
            <React.Fragment>
              <Typography style={{fontSize: "1.3rem"}} color="inherit"><b>Posto {seat} </b>
              &nbsp; <Typography style={{fontSize: ".9rem"}}>LIBERO</Typography>
              </Typography>
          
          </React.Fragment>
          }><button onClick={() => this.setSeat(seat)} className={availableButtonClasses} /></HtmlTooltip>
        ) :
        payed ? 
        (
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography style={{fontSize: "1.3rem"}} color="inherit"><b>Posto {seat} </b>
                &nbsp;<Chip style={{backgroundColor: '#5cc22f', color: "#fff"}} size="small" label={<Typography style={{fontSize: ".7rem"}}>PAGATO!</Typography>}></Chip>
                </Typography>
                <Typography style={{fontSize: ".9rem"}}>Prenotato il: <b>{moment(seatData?.bookedAt, "yyyy-MM-DD").format("DD/MM/yyyy")}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Nome: <b>{seatData.name} {seatData.surname}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Email: <b>{seatData.bookedBy}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Telefono: <b>{seatData.phone}</b></Typography>

                {/*<div style={{display: "flex", textAlign: "right", padding: ".45rem .25rem"}}>
                <Button variant="contained" onClick={deleteBookedSeat} style={{marginRight: "auto"}} color="error" size="small">Elimina</Button>
                </div>*/}
              </React.Fragment>
            }
          >
          <div onClick={() => this.setSeat(seat)} className={availableButtonClassesPayed}/>
          </HtmlTooltip>
        ) : 
        (
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography style={{fontSize: "1.3rem"}} color="inherit"><b>Posto {seat}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Prenotato il: <b>{moment(seatData?.bookedAt, "yyyy-MM-DD").format("DD/MM/yyyy")}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Nome: <b>{seatData.name} {seatData.surname}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Email: <b>{seatData.bookedBy}</b></Typography>
                <Typography style={{fontSize: ".9rem"}}>Telefono: <b>{seatData.phone}</b></Typography>

                {/*<div style={{display: "flex", textAlign: "right", padding: ".45rem .25rem"}}>
                <Button variant="contained" style={{marginRight: "auto"}} color="error" size="small">Elimina</Button>
                <Button variant="contained" onClick={setSeatPayed} style={{marginLeft: "auto"}} size="small">Pagato</Button>
                </div>*/}
              </React.Fragment>
            }
          >
          <div onClick={() => this.setSeat(seat)} className={availableButtonClassesBooked}/>
          </HtmlTooltip>
        )}
      </div>
    )
  }
}

export default SeatAdmin